import { getIn, useFormikContext } from 'formik';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { getTouchedError } from '../../utils/get-touched-error.util';
import type { CodeSuggestionHook } from './types/code-suggestion-hook.type';

const DEFAULT_FIELD_NAME = 'codingConfig.code';

interface Props {
  readonly fieldName?: string;
  readonly useCodeSuggestion: CodeSuggestionHook;
}

export const CodeSuggest = ({
  fieldName = DEFAULT_FIELD_NAME,
  useCodeSuggestion,
}: Readonly<Props>) => {
  const { errors, handleBlur, handleChange, touched, values } =
    useFormikContext();

  const { isLoading, codeSuggestionHandler } = useCodeSuggestion();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 3, lg: 2 }} sx={{ pt: 1, pb: 1 }}>
        <Button
          fullWidth
          loading={isLoading}
          onClick={codeSuggestionHandler}
          sx={{ height: '56px' }}
          variant="contained"
        >
          Générer Code
        </Button>
      </Grid>
      <Grid size={{ xs: 12, md: 9, lg: 10 }} sx={{ pt: 1, pb: 1 }}>
        <TextField
          error={!!(getIn(errors, fieldName) && getIn(touched, fieldName))}
          fullWidth
          helperText={getTouchedError(errors, touched, fieldName)}
          id="code-suggest-coding-config-code"
          label="Code"
          name={fieldName}
          onBlur={handleBlur}
          onChange={handleChange}
          required
          type="text"
          value={getIn(values, fieldName) as string}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
};
